import { render } from "./KycUnsuccess.vue?vue&type=template&id=7ea22176&ts=true"
import script from "./KycUnsuccess.vue?vue&type=script&lang=ts"
export * from "./KycUnsuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__